export const new_year_store = {
  namespaced: true,
  state() { return {
    viewNewYear: false,
  }},
  getters: {
    viewNewYear: state => state.viewNewYear
  },
  actions: {
    toggleViewNewYear({commit}) {
      commit('toggleViewNewYear')
    }
  },
  mutations: {
    toggleViewNewYear(state) {
      state.viewNewYear = !state.viewNewYear;
    }
  }
}